import Request from '@/libraries/request.js';
import Const from '@/const/const.js';

export default {
  BaseURL: '/purchaseorder',
  async get(url = null) {
    const purchaseOrders = await Request.getAsync(url);
    let orders = [];
    if (purchaseOrders.data.status) {
      orders = purchaseOrders.data.data;
      for (const [keyOrder, valueOrder] of Object.entries(orders)) {
        if (valueOrder.items.length > 0) {
          for (const [keyItem, valueItem] of Object.entries(valueOrder.items)) {
            if (valueItem.unit) {
              orders[keyOrder].items[keyItem].unit_text = Const.product_unit[valueItem.unit];
            } else {
              orders[keyOrder].items[keyItem].unit_text = Const.product_unit[valueItem.unit_buy];
            }
          }
        }
      }
    }
    return orders;
  },
  async get_order(ordId = null) {
    const url = ordId != null ? this.BaseURL + '/order/' + ordId : this.BaseURL + '/order';
    const data = await this.get(url);
    if (data && data.length == 1 && ordId != null) {
      return data[0];
    } else {
      return data;
    }
  },
  async get_order_by_date_range(startDate, endDate) {
    const url = this.BaseURL + '/order/?startDate=' + startDate + '&endDate=' + endDate;
    const data = await this.get(url);
    return data;
  },

  async get_supplier_order(supId = null) {
    if (supId == null) {
      throw new Error('Supplier ID not found.');
    }
    const url = this.BaseURL + '/order_supplier/' + supId;
    return await this.get(url);
  },

  async get_receivedList(ordId = null) {
    if (!ordId) return false;

    // console.log("get_receivedList");
    const url = this.BaseURL + '/order_received/' + ordId;
    const data = await this.get(url);
    // console.log(data);
    if (data && ordId != null) {
      return data;
    }
  },
};



// WEBPACK FOOTER //
// ./src/model/purchaseorder_model.js